import { ExternalLink as e } from "../ExternalLink/ExternalLink.js";
import { c as t } from "react/compiler-runtime";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/SupportLink/SupportLink.tsx
var r = "qodana-support@jetbrains.com", i = (i) => {
	let a = t(3), { label: o, email: s } = i, c = s === void 0 ? r : s, l = `mailto:${c}`, u = o ?? c, d;
	return a[0] !== l || a[1] !== u ? (d = /* @__PURE__ */ n(e, {
		href: l,
		children: u
	}), a[0] = l, a[1] = u, a[2] = d) : d = a[2], d;
};
//#endregion
export { r as QODANA_SUPPORT_EMAIL, i as SupportLink };
